import some from 'lodash/some';
import map from 'lodash/map';
import every from 'lodash/every';

export interface EacsAuthority {
    acctStructure: AcctStructure;
    eacsRole: string;
    role: string;
}

export interface AcctStructure {
    code: string;
    description: string;
}

export class UserInfo {
    authorities: Array<EacsAuthority> = undefined;
    displayName: string = undefined;
    eduPersonAffiliation: Array<string> = undefined;
    eduPersonPrimaryAffiliation: string = undefined;
    emailAddress: string = undefined;
    employeeId: string = undefined;
    firstName: string = undefined;
    homeDepartment: string = undefined;
    homeDepartmentCode: string = undefined;
    isActive: boolean = undefined;
    isSwitched = false;
    lastName: string = undefined;
    originalUsername: string = undefined;
    phoneNumber: string = undefined;
    separationDate: Date = undefined;
    title: string = undefined;
    titleCode: string = undefined;
    ucrClassStanding: string = undefined;
    ucrCollege: string = undefined;
    ucrEnrollmentStatus: string = undefined;
    ucrLastRegistered: Date = undefined;
    ucrOrg: string = undefined;
    ucrUniversityId: string = undefined;
    udcIdentifier: string = undefined;
    username: string = undefined;

    constructor(json: any) {
        for (const prop in json) {
            if (this.hasOwnProperty(prop)) {
                this[prop] = json[prop];
            }
        }
    }

    getAllAcctStructuresByRole(role: string): Array<AcctStructure> {
        if (!this.authorities) {
            return [];
        }

        return this.authorities
            .filter((authority: EacsAuthority) => authority.role === role)
            .map((authority: EacsAuthority) => {
                return authority.acctStructure;
            });
    }

    getAuthorityList(): Array<EacsAuthority> {
        return this.authorities;
    }

    ifAllGranted(roles: Array<string>): boolean {
        const authorityRoles = map(this.getAuthorityList(), (authority: EacsAuthority) => authority.role);

        return every(roles, (role: string) => authorityRoles.indexOf(role) >= 0);
    }

    ifAnyGranted(roles: Array<string>): boolean {
        return some(this.getAuthorityList(), (authority: EacsAuthority) => roles.indexOf(authority.role) >= 0);
    }

    ifNotGranted(roles: Array<string>): boolean {
        return !this.ifAnyGranted(roles);
    }
}
